import InitializingPage from '@app/components/InitializingPage'
import { actionCreators, IAccountState } from '@app/store/modules/account'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import {
  Redirect,
  Route,
  RouteComponentProps,
  RouteProps,
} from 'react-router-dom'

interface ISecureRouteProps {
  brokerage?: boolean
  development?: boolean
  guest?: boolean
  component: React.ComponentType<any>
}

type SecureRouteProps = RouteProps &
  ISecureRouteProps &
  IAccountState &
  typeof actionCreators

export default class SecureRoute extends React.Component<SecureRouteProps> {
  constructor(props: SecureRouteProps) {
    super(props)
    bindFunctions(this)
  }

  public componentDidMount() {
    if (!this.props.isInitialized) {
      this.props.initializeAccount()
    }
  }

  public componentDidUpdate(prevProps: SecureRouteProps) {
    if (
      prevProps.isInitialized !== this.props.isInitialized &&
      !this.props.isInitialized
    ) {
      this.props.initializeAccount()
    }
  }

  public render() {
    const { component, ...rest } = this.props

    return <Route {...rest} render={this._renderRoute(component)} />
  }

  private _canAccessRoute(): boolean {
    if (!this.props.user) {
      return false
    }

    return (
      this.props.user.permissions.isAdmin === true ||
      (this.props.brokerage === true &&
        this.props.user.permissions.isBrokerageUser) ||
      (this.props.development === true &&
        this.props.user.permissions.isDevelopmentUser) ||
      (this.props.guest === true && this.props.user.permissions.isGuest)
    )
  }

  private _isLoggedIn(): boolean {
    return this.props.user !== undefined
  }

  private _renderRoute(
    Component:
      | React.ComponentType<RouteComponentProps<any>>
      | React.ComponentType<any>,
  ) {
    return (props: any) => {
      if (!this.props.isInitialized) {
        return <InitializingPage />
      } else if (!this._isLoggedIn()) {
        return (
          <Redirect
            key={Date.now()}
            push
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      } else if (!this._canAccessRoute()) {
        return <div>Not Authorized</div>
      } else {
        return <Component {...props} />
      }
    }
  }
}
